<template>
  <PageWrapper
    :active-section="SECTION_PUBLICATIONS"
    :active-page="PAGE_PUBLICATION_FEED_GROUP_LIST"
    title="Feed Blogs"
    :breadcrumbs="breadcrumbs"
    page-name="Feed Blogs"
    align="left"
    width="full"
  >
    <ProfileWrapper
      :splash-image="feedGroup.image_url"
      :logo-image="publicationLogo"
      can-upload-splash
      can-edit-title
      can-edit-details
      :title="feedGroup.name"
      :details="feedGroup.description || 'Click here to add a description for your publication'"
      @click:save-title="saveFeedGroupName"
      @click:save-details="saveFeedGroupDescription"
      @click:splash-image="triggerUploadFeedGroupImage"
    >
      <iSpace :height="10" />
      <iColumn gap="large">
        <iRow>
          <iLink :href="fanWebFeedGroupUrl">
            View Feed Content
          </iLink>
        </iRow>
      </iColumn>
    </ProfileWrapper>
    <iUploader ref="feed-group-image-uploader" @upload-file="uploadFeedGroupImage" />
  </PageWrapper>
</template>

<script>
import { mapActions, mapState } from "pinia";
import PageWrapper from "@/components/PageWrapper";
import {
  PAGE_PUBLICATION_FEED_GROUP_LIST,
  SECTION_PUBLICATIONS,
} from "@/constants/nav-constants";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";
import { useFeedStore } from "@/stores/feed-store";
import ProfileWrapper from "@/components/publication/ProfileWrapper.vue";
export default {
  name: "PublicationFeedGroup",
  components: {
    PageWrapper,
    ProfileWrapper,
  },
  data() {
    return {
      PAGE_PUBLICATION_FEED_GROUP_LIST,
      SECTION_PUBLICATIONS,
    };
  },
  computed: {
    ...mapState(useCreatorPublicationStore, ["publicationId", "publicationLogo", "orgId"]),
    ...mapState(useFeedStore, ["feedGroup"]),
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: `/publication/org/${this.orgId}`, label: "My Publications" },
        { url: `/publication/${this.publicationId}`, label: "Overview" },
        { url: `/publication/${this.publicationId}/feed-groups`, label: "RSS Content" },
      ];
    },
    fanWebFeedGroupUrl() {
      return `${window.location.origin}/destination/${this.publicationId}/feed/${this.feedGroup.feed_group_id}`;
    },
  },
  methods: {
    ...mapActions(useFeedStore, [
      "saveFeedGroupName",
      "saveFeedGroupDescription",
      "saveFeedGroupImage",
    ]),
    uploadFeedGroupImage(file) {
      this.saveFeedGroupImage(file);
    },
    triggerUploadFeedGroupImage() {
      this.$refs["feed-group-image-uploader"].$refs.file.click();
    },
  },
};
</script>

<style scoped>
</style>
